"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceTimeSamplesFlattener = void 0;
/** convert [ { x, y, z }] to { x: [], y: [], z: []} */
const spaceTimeSamplesFlattener = (samples) => {
    return samples.reduce((a, c) => {
        const { x, y, z } = c;
        a.x.push(x);
        a.y.push(y);
        a.z.push(z);
        return a;
    }, { x: [], y: [], z: [] });
};
exports.spaceTimeSamplesFlattener = spaceTimeSamplesFlattener;
